export default __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu7mxKKTU1Kvnz.a79e0c15.woff2";